// Get Notifications
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS"
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS"
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL"

// Get Unread Count
export const GET_UNREAD_COUNT = "GET_UNREAD_COUNT"
export const GET_UNREAD_COUNT_SUCCESS = "GET_UNREAD_COUNT_SUCCESS"
export const GET_UNREAD_COUNT_FAIL = "GET_UNREAD_COUNT_FAIL"

// Add Notification
export const ADD_NOTIFICATION = "ADD_NOTIFICATION"
export const ADD_NOTIFICATION_SUCCESS = "ADD_NOTIFICATION_SUCCESS"
export const ADD_NOTIFICATION_FAIL = "ADD_NOTIFICATION_FAIL"

// Update Notification
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION"
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS"
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL"

// Delete Notification
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS"
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL"

// Mark as Seen
export const MARK_NOTIFICATION_AS_SEEN = "MARK_NOTIFICATION_AS_SEEN"
export const MARK_NOTIFICATION_AS_SEEN_SUCCESS = "MARK_NOTIFICATION_AS_SEEN_SUCCESS"
export const MARK_NOTIFICATION_AS_SEEN_FAIL = "MARK_NOTIFICATION_AS_SEEN_FAIL"

// Reset Flag
export const RESET_NOTIFICATION_FLAG = "RESET_NOTIFICATION_FLAG"
